<template>
    <div
        class="loading-wrapper"
        :class="{ hide: loadingEnd }"
        v-if="!loadingHide"
    >
        <div class="loading" @click="goFun">
            <div class="click_tips" :class="[{ show: progress >= 100 }]">
                {{ $t('base.loading_tapTips') }}
            </div>
            <div class="arrow" :class="[{ show: progress >= 100 }]"></div>
            <!-- <div class="egg"></div> -->
            <div class="shake" ref="shakeRef"></div>
            <div class="split" :class="{ show: shakeEnd }" ref="splitRef"></div>
            <p class="slogan" v-html="$t('base.loadingSlogan')"></p>
            <p class="loading-rate">{{ progress }}%</p>
        </div>
        <p class="copyright"></p>
    </div>
</template>

<script>
import lottie from 'lottie-web';
import LS from '@/utils/storage.js';
import { LS_PREFIX } from '@/config';
import { mapActions, mapMutations } from 'vuex';
import { urlParser, getQueryString, isIOS, isAndroid } from '@/utils';
import { Bus } from '@/utils/eventBus.js';
import i18n from '@/lang';
export default {
    name: 'loading',
    props: {
        progress: {
            type: Number,
            default: 0
        }
    },
    watch: {
        progress(val) {
            this.handleLoad(val);
        }
    },
    data() {
        return {
            // 晃动结束
            shakeEnd: false,
            // loading播放结束
            loadingEnd: false,
            // loading是否隐藏
            loadingHide: false,
            // 进度百分比
            progressNum: 0,
            // 晃动lottie实例
            egg_shake_ani: null,
            // 裂开lottie实例
            egg_split_ani: null,
            cd: null
        };
    },
    mounted() {
        const self = this;
        self.loadingInit();
        // self.loadingStart();
    },
    methods: {
        ...mapMutations(['SET_LANG', 'SET_STATE', 'SHOW_POPUP']),
        ...mapActions(['showComm']),
        // 初始化序列帧
        loadingInit() {
            console.log('yo');
            // 设置初始化语言 start
            const self = this;
            const LS_lang = LS.get(LS_PREFIX + 'lang1');
            // const navigator_lang = navigator.language;
            let lang = '';
            if (LS_lang) {
                lang = LS_lang;
            } else if (location.href.indexOf('ru.html') > -1) {
                lang = 'ru';
            } else {
                lang = this.$store.state.lang || 'en';
            }
            if (!LS_lang) {
                LS.save(LS_PREFIX + 'lang1', lang);
            }
            this.SET_LANG(lang);
            this.$i18n.locale = lang;
            // 活动结束弹窗
            this.showComm({
                text: i18n.t('base.activityEnd'),
                size: 'big',
                hasCls: false
            });
            // 设置初始化语言 end
            self.egg_shake_ani = lottie.loadAnimation({
                container: self.$refs.shakeRef, // Required
                path: 'egg_shake.json', // Required
                renderer: 'canvas', // Required
                loop: true, // Optional
                autoplay: false
            });
            self.egg_split_ani = lottie.loadAnimation({
                container: self.$refs.splitRef, // Required
                path: 'egg_split.json', // Required
                renderer: 'canvas', // Required
                loop: false, // Optional
                autoplay: false
            });
            self.egg_shake_ani.setSpeed(0.3);
            self.egg_split_ani.setSpeed(0.5);
            // 开始播放
            self.egg_shake_ani.play();
        },
        // 废弃 - 播放蛋蛋晃动序列帧
        loadingStart() {
            const self = this;
            self.egg_shake_ani.play();
            self.cd = setInterval(() => {
                self.progressNum += 1;
                // 进度100%
                if (self.progressNum == 100) {
                    clearInterval(self.cd);
                    self.egg_shake_ani.onLoopComplete = function() {
                        self.egg_shake_ani.stop();
                        self.shakeEnd = true;
                        self.egg_shake_ani.destroy();
                        self.egg_split_ani.play();
                    };
                }
            }, 10);
            // 裂开动画结束
            self.egg_split_ani.onComplete = function() {
                self.loadingEnd = true;
                setTimeout(() => {
                    self.loadingHide = true;
                }, 1000);
            };
        },
        // 加载进度
        handleLoad() {
            const self = this;
            let _progress = this.progress;
            // 进度100%
            // if (_progress == 100) {
            //     self.egg_shake_ani.onLoopComplete = function() {
            //         self.egg_shake_ani.stop();
            //         self.shakeEnd = true;
            //         self.egg_shake_ani.destroy();
            //         self.egg_split_ani.play();
            //     };
            // }
            // // 裂开动画结束
            // self.egg_split_ani.onComplete = function() {
            //     self.loadingEnd = true;
            //     setTimeout(() => {
            //         self.loadingHide = true;
            //     }, 1000);
            // };
        },
        // 点击进入
        goFun() {
            const self = this;
            let _progress = this.progress;
            let _bgmState = this.$store.state.bgmPlayState;
            let _volume = this.$store.state.bgmVolume;
            if (_progress < 100) return;
            if (!_bgmState) {
                createjs.Sound.play('bgm', {
                    loop: -1,
                    volume: _volume
                });
                // 更新BGM播放状态
                this.SET_STATE({
                    key: 'bgmPlayState',
                    val: !_bgmState
                });
            }
            // 加载完成，点击进入
            self.egg_shake_ani.onLoopComplete = function() {
                self.egg_shake_ani.stop();
                self.shakeEnd = true;
                self.egg_shake_ani.destroy();
                self.egg_split_ani.play();
            };
            // 裂开动画结束
            self.egg_split_ani.onComplete = function() {
                self.loadingEnd = true;
                setTimeout(() => {
                    self.loadingHide = true;
                }, 1000);

                // 0710
                self.initGameView();
            };
        },
        // 初始化游戏界面
        async initGameView() {
            const myurl = urlParser(location.href);
            const token = LS.get(LS_PREFIX + 'token');
            let _dragonList = this.$store.state.game.dragonList;
            let _pkwordsList = this.$store.state.game.pkwordsList;
            let _userinfo = this.$store.state.userinfo;

            // 初始化游戏数据
            gameAni.setDragonData(_dragonList);
            gameAni.updatePkWords(_pkwordsList);

            if (!this.$store.state.userinfo) {
                // 未登录
                Bus.$emit('_goPage', 'start'); // 登录前动画
            } else {
                // 已登录
                if (!_userinfo.user_name) {
                    // 没名字，第一次走流程
                    Bus.$emit('_goPage', 'empty');
                    this.SHOW_POPUP('saveName');
                } else {
                    // 有名字
                    if (_userinfo.dragon_id) {
                        Bus.$emit('_goPage', 'empty');
                        Bus.$emit('_initPage');
                    } else {
                        // 无龙
                        Bus.$emit('_goPage', 'create');
                    }
                }
            }
        }
    }
};
</script>

<style lang="less" scoped>
.loading-wrapper {
    width: 100%;
    height: 100%;
    background: url(~@/assets/img/loading_bg.jpg) top center/cover no-repeat;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    opacity: 1;

    &.hide {
        transition: opacity 0.8s ease-in-out;
        opacity: 0;
        pointer-events: none;
    }

    .loading {
        width: 100%;
        // height: 490px;
        position: relative;
        padding-top: 340px;

        .click_tips {
            position: absolute;
            width: 100%;
            line-height: 50px;
            top: -220px;
            left: 0;
            font-size: 28px;
            color: #33160f;
            text-align: center;
            opacity: 0;
            transition: 0.3s;

            &.show {
                opacity: 1;
            }
        }

        .arrow {
            position: absolute;
            width: 128/2px;
            height: 155/2px;
            background: url(~@/assets/img/icon_arrow2.png) center no-repeat;
            background-size: 100% 100%;
            // background: url(~@/assets/img/icon_arrow.png) center no-repeat;
            // background-size: 42px 48px;
            top: -150px;
            left: 50%;
            margin-left: -128/4px;
            opacity: 0;
            transition: 0.3s;

            &.show {
                opacity: 1;
                animation: updown 1s infinite;
            }

            &.ani {
                animation: updown 1s infinite;
            }

            @keyframes updown {
                0% {
                    transform: translate(0, 0);
                }
                50% {
                    transform: translate(0, 30px);
                }
                100% {
                    transform: translate(0, 0);
                }
            }
        }

        .shake {
            position: absolute;
            top: 0;
            left: 0;
        }

        .split {
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;

            &.show {
                opacity: 1;
            }
        }

        .egg {
            width: 204px;
            height: 268px;
            background: url(~@/assets/img/egg_0.png) center/contain no-repeat;
            margin: 0 auto;
        }

        .slogan {
            font-size: 34px;
            line-height: 1;
            color: #33160f;
            text-align: center;
            margin-top: 14px;
        }

        &-rate {
            font-size: 96px;
            color: #6eb7db;
            text-align: center;
            margin-top: 60px;
        }
    }

    .copyright {
        width: 380px;
        height: 26px;
        background: url(~@/assets/img/copyright1.png) center/100% 100% no-repeat;
        position: absolute;
        left: 50%;
        margin-left: -190px;
        bottom: 35px;
    }
}
</style>
